import { Link } from 'react-router-dom';
import { t } from '../lib/i18n.js';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-ink-muted">404</p>
      <h1 className="text-2xl font-semibold text-ink">{t('common.notFound')}</h1>
      <Link to="/" className="text-sm text-brand hover:text-brand-hover">{t('common.back')}</Link>
    </div>
  );
}
